export default __webpack_public_path__ + "static/media/04_DAIF_Infra_03_02_poweredge_loop.f037ee22.mp4";